import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedButton, SharedFormField } from "../../components/shared";
import ChoiceGroup from "../../components/forms/ChoiceGroup";
import { useSellerState } from "../../js/state/sellerState";

function emptyImprovement() {
  return { id: crypto.randomUUID(), work: "", timing: "", notes: "" };
}

export default function SellerImprovements() {
  const saved = useSellerState().seller.portfolio.improvements || {};
  const [form, setForm] = useState({
    strategy: saved.strategy || "",
    items: saved.items?.length ? saved.items : [emptyImprovement()],
    notes: saved.notes || "",
  });

  function updateItem(id, event) {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      items: current.items.map((item) => (item.id === id ? { ...item, [name]: value } : item)),
    }));
  }

  return (
    <SellerStep
      title="Improvements"
      lead="Work you still might do before listing — versus leaving it for the buyer. This keeps pricing and timeline honest."
      sectionKey="improvements"
      value={form}
    >
      <section className="checklist-section">
        <h2>Before-List Strategy</h2>
        <ChoiceGroup
          label="Overall approach"
          name="strategy"
          value={form.strategy}
          onChange={(event) => setForm((current) => ({ ...current, strategy: event.target.value }))}
          options={[
            { value: "as-is", label: "List as-is" },
            { value: "light", label: "Light prep only" },
            { value: "targeted", label: "Targeted repairs" },
            { value: "renovate", label: "Larger updates first" },
          ]}
        />
        {form.items.map((item, index) => (
          <div key={item.id} className="seller-repeat-row">
            <p className="field-label">Planned item {index + 1}</p>
            <SharedFormField
              label="Work"
              name="work"
              value={item.work}
              onChange={(event) => updateItem(item.id, event)}
              placeholder="Paint, carpet, fence, HVAC service…"
            />
            <SharedFormField
              label="Timing"
              name="timing"
              type="select"
              value={item.timing}
              onChange={(event) => updateItem(item.id, event)}
              options={[
                { value: "before-list", label: "Before list" },
                { value: "during", label: "During showings" },
                { value: "credit", label: "Offer as credit instead" },
                { value: "skip", label: "Will not do" },
              ]}
            />
            <SharedFormField
              label="Notes"
              name="notes"
              type="textarea"
              rows={2}
              value={item.notes}
              onChange={(event) => updateItem(item.id, event)}
            />
            {form.items.length > 1 ? (
              <SharedButton
                variant="ghost"
                onClick={() =>
                  setForm((current) => ({
                    ...current,
                    items: current.items.filter((entry) => entry.id !== item.id),
                  }))
                }
              >
                Remove
              </SharedButton>
            ) : null}
          </div>
        ))}
        <SharedButton
          variant="secondary"
          onClick={() => setForm((current) => ({ ...current, items: [...current.items, emptyImprovement()] }))}
        >
          Add planned work
        </SharedButton>
        <SharedFormField
          label="Improvement notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))}
          placeholder="Budget cap, contractor already booked, what must be done vs. optional."
        />
      </section>
    </SellerStep>
  );
}
